import { render, staticRenderFns } from "./BdContact.vue?vue&type=template&id=7e0f9e3d&"
import script from "./BdContact.vue?vue&type=script&lang=js&"
export * from "./BdContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports